import React from "react";

import { Box, Grid, Typography } from "@mui/material";
import firstCharToUpper from "../helpers/stringFormat";
import { formatNumberThsndAndDec } from "../helpers/stringFormat";

const ProductDisplay = ({ presentation }) => {
    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: 600,      // constrain the width for better layout
                mx: 'auto',        // center horizontally
                p: 2,
                color: 'white',
            }}
        >
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={4} sx={{ textAlign: 'right' }}>
                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Product:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body1">
                        {presentation.product.name}
                    </Typography>
                </Grid>
                <Grid item xs={4} sx={{ textAlign: 'right' }}>
                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Revenue model:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body1">
                        {presentation.product.revenue_model === 'transactional' ?
                            `${firstCharToUpper(presentation.product.revenue_model)} with a price per ${presentation.product.unit}`
                            : `Subscription with a ${presentation.product.frequency} price${presentation.product.unit.length > 0 ? ' per ' + presentation.product.unit : ''}`}
                    </Typography>
                </Grid>
                <Grid item xs={4} sx={{ textAlign: 'right' }}>
                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Alternative:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography variant="body1">
                        {`${presentation.product.alternative} with a cost of ${presentation.product.currency + formatNumberThsndAndDec(presentation.product.price_alternative)} ${presentation.product.revenue_model === 'transactional' && presentation.product.unit.length > 0 ? 'per ' + presentation.product.unit : ''}${presentation.product.revenue_model === 'subscription' && presentation.product.unit.length > 0 ? presentation.product.frequency + ' per ' + presentation.product.unit : presentation.product.frequency}`}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default ProductDisplay